<template>
	<div :style="{ fontSize: settings.fontSize }" :class="[settings.class]" :id="settings.id">
		<input :id="settings.inputId" :tabindex="disabled ? null : tabindex" class="nikan-checkbox" type="checkbox" @change="valueChanged" :checked="isChecked" :disabled="disabled ? true : null" @click="checkboxClicked" ref="input">
		<label :for="settings.inputId">{{ settings.title }}</label>
	</div>
</template>
<script>
	import Merge from 'lodash/merge'
	export default {
		props: {
			options: { type: Object, required: false },
			modelValue: { type: [Boolean, String] },
			tabindex: { type: [Number, String] },
			startup: { type: Boolean, default: false },
			disabled: { type: Boolean, default: false },
			checked: { type: Boolean, default: false }
		},
		emits: ['update:modelValue', 'click'],
		watch: {
			options: {
				deep: true,
				immediate: true,
				handler(val) {
					this.settings = Merge(this.settings, val)
				}
			},
		},
		data() {
			return {
				settings: {
					fontSize: '1rem',
					title: '',
					class: '',
					id: '',
					value: '',
					isChecked: false,
					inputId: this.idGenerator(),
				}
			}
		},
		computed: {
			isChecked() {
				return this.modelValue === true || this.modelValue === this.settings.value || this.settings.isChecked || this.checked
			}
		},
		methods: {
			checkboxClicked() {
				this.$emit('click', this.settings.value)
			},
			valueChanged(e) {
				const val = e.target.checked ? this.settings.value || true : false
				this.$emit('update:modelValue', val)
			}
		},
	}
</script>
<style scoped></style>